import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Form, Spin, Card, Row, Input } from 'antd';
import { Prompt } from 'dva/router';
import { PropTypes } from 'prop-types';
import ButtonBar from '../../ButtonBar/ButtonBar';
import { ROUTE_CAMPAIGNS_LIST } from '../../../routes';

const CampaignsItem = (props) => {
  const projectId = props.app.currentProjectId || props.match.params.projectId;
  const campaignId = props.match.params.campaignId;
  const [isSubmited, setState] = useState(false);

  const getCurrentCampaign = () => {
    props.dispatch({
      type: 'campaigns/getCampaignById',
      payload: { projectId, campaignId },
    });
  };

  useEffect(() => {
    props.dispatch({
      type: 'header/update',
      payload: {
        title: campaignId
          ? 'Component.Campaigns.Item.Edit'
          : 'Component.Campaigns.Create',
      },
    });
    if (campaignId) {
      getCurrentCampaign();
    }
  }, []);

  const showNotification = () => {
    props.dispatch({
      type: 'app/addNotification',
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: `Component.Campaigns.${campaignId ? 'Update' : 'New'}.Success.Text`,
      },
    }).then(() => props.dispatch({ type: 'app/showNotifications' }));
  };

  const cancelAction = () => {
    props.dispatch({
      type: 'app/goToRoute',
      payload: {
        projectId,
        routeName: ROUTE_CAMPAIGNS_LIST,
      },
    });
  };

  const sendData = (type, payload) => {
    return props.dispatch({ type, payload }).then((response) => {
      if (response.success) {
        props.dispatch({
          type: 'app/goToRoute',
          payload: {
            projectId,
            routeName: ROUTE_CAMPAIGNS_LIST,
          },
        }).then(() => showNotification());
      }
    });
  };

  const handleSubmit = () => {
    const { label, key, name } = props.form.getFieldsValue();
    sendData(
      campaignId ? 'campaigns/updateCampaign' : 'campaigns/createCampaign',
      {
        campaigns: { label, key, name },
        campaignId,
        projectId,
      },
    );
    setState(true);
  };

  return (
    <Spin spinning={!!props.loading.models.campaigns}>
      <Form onSubmit={handleSubmit}>
        <Prompt
          when={!isSubmited && props.form.isFieldsTouched()}
          message={props.intl.locale}
        />
        <Card>
          <Row>
            <Form.Item label={<FormattedMessage id="Component.Campaign.Item.Label" />}>
              {props.form.getFieldDecorator('label', {
                initialValue: campaignId ? props.campaigns.campaignsList[0].label : '',
                rules: [{
                  required: true,
                  min: 3,
                }],
              })(<Input />)}
            </Form.Item>
            <Form.Item label={<FormattedMessage id="Component.Campaign.Item.Key" />}>
              {props.form.getFieldDecorator('key', {
                initialValue: campaignId ? props.campaigns.campaignsList[0].key : '',
                rules: [{
                  required: true,
                  min: 3,
                }],
              })(<Input />)}
            </Form.Item>
            <Form.Item label={<FormattedMessage id="Component.Campaign.Item.Name" />}>
              {props.form.getFieldDecorator('name', {
                initialValue: campaignId ? props.campaigns.campaignsList[0].name : '',
                rules: [{
                  required: true,
                  min: 3,
                }],
              })(<Input />)}
            </Form.Item>
          </Row>
        </Card>
        <ButtonBar cancelAction={() => cancelAction()} />
      </Form>
    </Spin>
  );
};

CampaignsItem.propTypes = {
  campaignsList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
  })),
};

export default connect(({ app, loading, campaigns }) => ({ app, loading, campaigns }))(Form.create()(injectIntl(CampaignsItem)));



// WEBPACK FOOTER //
// ./src/components/Campaigns/CampaignsItem/CampaignsItem.js